import React, { useState } from 'react'
import { Check, Copy } from '../../svg/Icons';
import GoogleAnalytics from '../GA';

interface MPKAreaProps{
    mpk:string
    title:string
    error?:boolean;
}

function parseMpk(mpk: string): string {
    try {
        return JSON.stringify(JSON.parse(mpk), null, 2)
    } catch(_) {
        return mpk
    }
}

const MPKArea = (props: MPKAreaProps) => {

    const [copySuccess, setCopySuccess] = useState('');

    const mpk = parseMpk(props.mpk);

    let title = props.title;

    const handleCopy = async () => {
        navigator.clipboard.writeText(mpk || '');

        setCopySuccess('Copied ' + props.title);
        setTimeout(() => setCopySuccess(''), 1000); // Clear success message after 2 seconds

        /*try {
            //await navigator.clipboard.writeText(text);
            props.handleCopy();
            setCopySuccess('Copied ' + props.sectionTitle);
            setTimeout(() => setCopySuccess(''), 1000); // Clear success message after 2 seconds
        } catch (err) {
            setCopySuccess('Failed to copy!');
        }*/
    };
  return (
    <div className={(props.error ? " text-red-700 bg-red-50 border-red-500 " : " ") + "flex  flex-col items-center justify-center rounded-lg border border-gray-300 p-3 dark:border-gray-600"}>
        <div className='flex w-full cursor-pointer justify-between gap-2  text-sm font-medium'>
            <div className={`group flex w-full items-center justify-between rounded py-2 pl-1 pr-3 transition-all duration-150 ease-in-out ${copySuccess === '' ? 'hover:bg-primary-50 dark:hover:bg-gray-700' : 'bg-green-100 hover:bg-green-100  dark:hover:bg-gray-700 dark:bg-gray-700'}`} onClick={() => {handleCopy();GoogleAnalytics("Generate MPK", "btn_copyMPK_"+{title}+"", "Button to copy MPK")}}>
                <p className='uppercase text-gray-600 dark:text-gray-400 text-sm font-medium'>{props.title}</p>
                <div className='flex items-center gap-2 md:opacity-0 group-hover:opacity-100 '>
                    {copySuccess === '' ? (
                        <>
                            <Copy className='size-4 text-gray-500' />
                            <p className='hidden md:flex text-sm font-medium text-gray-600 dark:text-gray-400'>Copy {props.title}</p>
                        </>
                    ) : (
                        <>
                            <Check className='size-4 text-green-500' />
                            <p className='hidden md:flex text-sm font-medium text-green-500'>{copySuccess}</p>
                        </>
                    )}
                </div>
            </div>
        </div>

        <pre className={(props.error ? " text-red-700 bg-red-50 border-red-500 " : " ") +"max-w-[876px] w-full break-all whitespace-pre-wrap flex flex-col items-left justify-center px-1 py-3 dark:text-white"}>
            {mpk}
        </pre>

    </div>
  )
}

export default MPKArea
